import React from "react";
import Header from "../../../header/Header";
import NextBtn from "../../../common/NextBtn";
import PrevBtn from "../../../common/PrevBtn";
import { NavLink } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Sidebar from "../../../common/Sidebar";

const Chapter03Screen06 = () => {
	const { t, i18n } = useTranslation();
	return (
		<>
			<div className="wrapper bg-bd-2 hp">
				<div
					className="fixed-header"

				>
					<div className="container-fluid cf-set">
						<Header leftChapter="2/4" percentage="67" star="50" />
					</div>
				</div>
				<div className="d-flex">
					<Sidebar />
					<div className="data-adjust">
						<div className="container-fluid cf-set">
							<div className="row align-items-top justify-content-between pt-20 mt-5 mt-m-3">
								<div className="col-lg-12 wow fadeInDown" data-wow-duration="1s" data-wow-delay="0.2s">

									<h2 className="h2 ">{t('learn')} </h2>
									<h3 className="h3 ">{t('M6chapter03screen06Text1')} </h3>

									<div className="row row-cols-2 row-cols-lg-5 mt-4">
										<div className="col d-flex">
											<div className="serviceBox">
												<div className="service-icon">
													<center><img src="/assets/img/md6/adolescent-empowerment-program.gif" alt="" /></center>
												</div>
												<p className="description mt-2">{t('M6chapter03screen06Text2')} <span class="red">{t('M6chapter03screen06Text3')}</span> {t('M6chapter03screen06Text4')}</p>
												<a href="https://inbreakthrough.org/adolescent-empowerment-programme-endline-survey-from-uttar-pradesh-proves-that-social-norm-change-is-possible/" className="read-more" target="_blank">{t('Knowmore')} <i class="bi bi-chevron-right"></i></a>
											</div>
										</div>
										<div className="col  d-flex">
											<div className="serviceBox">
												<div className="service-icon">
													<center><img src="/assets/img/md6/sexual-harassment.gif" alt="" /></center>
												</div>
												<p className="description mt-2">{t('M6chapter03screen06Text5')} <span class="red">{t('M6chapter03screen06Text6')}</span> {t('M6chapter03screen06Text7')}</p>
												<a href="https://inbreakthrough.org/building-gender-equitable-behaviours-in-adolescents-through-government-partnerships/" className="read-more" target="_blank">{t('Knowmore')} <i class="bi bi-chevron-right"></i></a>
											</div>
										</div>

										<div className="col  d-flex">
											<div className="serviceBox">
												<div className="service-icon">
													<center><img src="/assets/img/md6/early-marriage.gif" alt="" /></center>
												</div>
												<p className="description mt-2">{t('M6chapter03screen06Text8')} <span class="red">{t('M6chapter03screen06Text9')}</span> {t('M6chapter03screen06Text10')}<span class="red">{t('M6chapter03screen06Text11')}</span> {t('M6chapter03screen06Text12')}</p>
												<a href="https://inbreakthrough.org/early-marriage-and-continued-learning/" className="read-more" target="_blank">{t('Knowmore')} <i class="bi bi-chevron-right"></i></a>
											</div>
										</div>

										<div className="col  d-flex">
											<div className="serviceBox">
												<div className="service-icon">
													<center><img src="/assets/img/md6/gender-biased-sex-selection.gif" alt="" /></center>
												</div>
												<p className="description mt-2"> <span class="red">{t('M6chapter03screen06Text13')}</span> {t('M6chapter03screen06Text14')}</p>
												<a href="https://inbreakthrough.org/adolescent-empowerment-programme-endline-survey-from-uttar-pradesh-proves-that-social-norm-change-is-possible/" className="read-more" target="_blank">{t('Knowmore')} <i class="bi bi-chevron-right"></i></a>
											</div>
										</div>

										<div className="col d-flex">
											<div className="serviceBox">
												<div className="service-icon">
													<center><img src="/assets/img/md6/domestic-violence.gif" alt="" /></center>
												</div>
												<p className="description mt-2"> {t('M6chapter03screen06Text15')}<span class="red">{t('M6chapter03screen06Text16')}</span> {t('M6chapter03screen06Text17')}</p>
												<a href="https://inbreakthrough.org/adolescent-empowerment-programme-endline-survey-from-uttar-pradesh-proves-that-social-norm-change-is-possible/" className="read-more" target="_blank">{t('Knowmore')} <i class="bi bi-chevron-right"></i></a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				className="button-fixed wow fadeInDown"
				data-wow-duration="1s"
				data-wow-delay="0.2s"
			>
				<div className="container-fluid cf-set">
					<div className="row">
						<div className="col-lg-12">
							<div className=" d-flex justify-content-end">

								<PrevBtn link="/module-06/chapter-03-screen-04" />
								<NextBtn link="/module-06/chapter-03-screen-07" text={t('CommonBtnGoNext')} />


							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Chapter03Screen06;
